// https://docs.sentry.io/platforms/javascript/configuration/filtering/#decluttering-sentry
export const SENTRY_IGNORE_LIST = [
  // Random plugins/extensions
  "top.GLOBALS",
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  "originalCreateNotification",
  "canvas.contentDocument",
  "MyApp_RemoveAllHighlights",
  "http://tt.epicplay.com",
  "Can't find variable: ZiteReader",
  "jigsaw is not defined",
  "ComboSearch is not defined",
  "http://loading.retry.widdit.com/",
  "atomicFindClose",
  // Facebook borked
  "fb_xd_fragment",
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
  // reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268
  "bmi_SafeAddOnload",
  "EBCallBackMessageReceived",
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  "conduitPage",
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications.",
  "Can't find variable: $",
  "$ is not defined",
  // Google Maps script errors
  /^Could not load "(util|controls|overlay|onion|stats|places_impl)".*$/,
  "The object can not be cloned.",
  "NotSupportedError: The operation is not supported.",
  "NotSupportedError: Failed to load because no supported source was found.",
  "t.isActive is not a function",
  "Response returned with non-OK status",
  /^SecurityError: Blocked a frame with origin .* from accessing a cross-origin frame.*$/,
  // Gubagoo errors
  "The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.",
  "Illegal invocation",
  "Invalid regular expression: invalid group specifier name",
  /^(NotAllowedError|AbortError): (play\(\) failed|The play method|The play\(\) request was interrupted).*$/,
  /^(TypeError:\s*)?window\.ggConfig\.get.*$/,
  /^Failed to execute 'setItem' on 'Storage':.*$/,
  "ReferenceError: jQuery is not defined",
  "ReferenceError: Can't find variable: jQuery",
  "Cannot find module './111753'",
  // Hotjar errors
  "TypeError: Cannot read properties of undefined (reading 'site_id')",
  "TypeError: undefined is not an object (evaluating 'hj.settings.site_id')",
  // ignore gzip errors, match any pattern of: ".gzip"
  /^TypeError: undefined is not an object \(evaluating '.*\.gzip'\)$/,
  // See https://github.com/getsentry/sentry-javascript/issues/10011
  "Cannot read properties of undefined (reading 'domInteractive')",
  "Failed to load Stripe.js",
  "TypeError: undefined is not an object (evaluating 'a.L')",
  "Object captured as promise rejection with keys: message, status, statusText",
  // Convert errors due to AdBlockers we can't avoid
  /^Non-error exception from Convert: {"message":"(Load failed|Failed to fetch|NetworkError when attempting to fetch resource.)"}*$/,
  // Missing Variables:
  // gmo: Google browser ver 354-355 issue on IOS devices. See: https://issuetracker.google.com/issues/396043331
  /^Can't find variable: (ZiteReader|\$|gmo|_AutofillCallbackHandler|__AutoFillPopupClose__|IFrameMessageHandler)$/,
  // https://forum.sentry.io/t/typeerror-failed-to-fetch-reported-over-and-overe/8447
  // https://github.com/getsentry/sentry-javascript/issues/7275
  "TypeError: Failed to fetch",
  "TypeError: Load failed",
  /^Error invoking (enableDidUserTypeOnKeyboardLogging|postMessage|enableButtonsClickedMetaDataLogging): Java object is gone*$/,
  "Java object is gone",
  /^Error invoking postMessage: (Java exception was raised during method invocation|Java bridge method invocation error)*$/,
  // iOS WKWebView Errors
  /^TypeError: undefined is not an object \(evaluating 'window\.webkit\.messageHandlers.*'\)$/,
  /^UnhandledRejection: Non-Error promise rejection captured with value:.*$/,
  /^SecurityError: The operation is insecure.*$/,
];

export default {};
